// ============================================
// CONFIGURATION
// ============================================
const CART_THRESHOLD = 17500;          // $175.00 in cents
const VARIANT_ID = 47700253671639;     // <-- your free gift variant ID (NUMBER)

let isProcessing = false;

// ============================================
// CART HELPERS
// ============================================

// Get current cart data
async function getCart() {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Failed to fetch cart');
    const cart = await response.json();
    console.log('Current cart:', cart);
    return cart;
  } catch (error) {
    console.error('Error fetching cart:', error);
    return null;
  }
}

// Check if variant is in cart AND return its line item if found
function findVariantLineItem(cart, variantId) {
  if (!cart || !cart.items) return null;

  const targetId = Number(variantId);
  console.log('Looking for variant in cart, targetId =', targetId);

  cart.items.forEach((item, index) => {
    console.log('Cart item', index + 1, {
      title: item.title,
      id: item.id,
      variant_id: item.variant_id,
      key: item.key,
      line_index: index + 1
    });
  });

  const lineItem = cart.items.find(item => {
    const itemId = Number(item.id || item.variant_id);
    return itemId === targetId;
  });

  if (lineItem) {
    console.log('Matched free gift line item:', {
      title: lineItem.title,
      id: lineItem.id,
      variant_id: lineItem.variant_id,
      key: lineItem.key
    });
  } else {
    console.log('No line item found matching variantId:', targetId);
  }

  return lineItem;
}

// Simple boolean wrapper
function isVariantInCart(cart, variantId) {
  return !!findVariantLineItem(cart, variantId);
}

// Add free gift
async function addFreeGift(variantId) {
  try {
    console.log('Adding free gift, variant ID:', variantId);

    const formData = {
      items: [{
        id: variantId,
        quantity: 1
      }]
    };

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Failed to add free gift: ${text}`);
    }

    const data = await res.json();
    console.log('Free gift added:', data);
    return data;
  } catch (e) {
    console.error('Error adding free gift:', e);
    throw e;
  }
}

// Remove free gift, trying key first, then line index
async function removeFreeGiftByVariant(variantId) {
  try {
    const cart = await getCart();
    if (!cart || !cart.items) {
      console.error('No cart/items when trying to remove free gift');
      return;
    }

    const lineItem = findVariantLineItem(cart, variantId);
    if (!lineItem) {
      console.log('Free gift not found in cart, nothing to remove');
      return;
    }

    // Find the line index (1-based) of this item
    const lineIndex = cart.items.findIndex(i => i.key === lineItem.key) + 1;

    console.log('Attempting removal with line item key:', lineItem.key);
    console.log('Line index:', lineIndex);

    // First try with id: key
    let res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineItem.key,
        quantity: 0
      })
    });

    if (!res.ok) {
      const text = await res.text();
      console.warn('Remove by key failed, response:', text);

      // Fallback: try using line index instead
      console.log('Falling back to removal by line index:', lineIndex);

      res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: lineIndex,
          quantity: 0
        })
      });

      if (!res.ok) {
        const text2 = await res.text();
        throw new Error(`Failed to remove free gift by key + line: ${text2}`);
      }
    }

    const data = await res.json();
    console.log('Free gift removed successfully:', data);
    return data;
  } catch (e) {
    console.error('Error removing free gift:', e);
    throw e;
  }
}

// ============================================
// CART-NOTIFICATION REFRESH (OPTION 1)
// ============================================

async function hardRefreshCartUI() {
  try {
    console.log('Refreshing cart UI via cart-notification sections');

    // 1) Fetch sections HTML for cart-notification + cart icon bubble
    const url = window.location.pathname + '?sections=cart-notification-product,cart-notification-button,cart-icon-bubble';
    const response = await fetch(url);

    if (!response.ok) {
      console.warn('Failed to fetch cart sections, status:', response.status);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    }

    const sectionsData = await response.json();

    // 2) Get current cart to determine last product id (for notification)
    const cart = await getCart();

    // If cart has items, use the last item as the product for notification
    const lastItem = cart && cart.items && cart.items.length > 0
      ? cart.items[cart.items.length - 1]
      : null;

    const productId = lastItem ? lastItem.product_id : 0;

    const parsedState = {
      id: productId,
      sections: sectionsData
    };

    // 3) Find cart-notification element and render
    const cartNotification = document.querySelector('cart-notification');

    if (cartNotification && typeof cartNotification.renderContents === 'function') {
      console.log('Calling cartNotification.renderContents with parsedState');
      cartNotification.renderContents(parsedState);
    } else {
      console.warn('cart-notification element not found or has no renderContents method');

      // Fallback: update cart icon bubble directly if present
      const bubbleHtml = sectionsData['cart-icon-bubble'];
      const cartIconBubble = document.getElementById('cart-icon-bubble');

      if (bubbleHtml && cartIconBubble) {
        const bubbleDOM = new DOMParser()
          .parseFromString(bubbleHtml, 'text/html')
          .querySelector('.shopify-section');

        if (bubbleDOM) {
          cartIconBubble.innerHTML = bubbleDOM.innerHTML;
        }
      }
    }
  } catch (e) {
    console.error('Error refreshing cart UI:', e);
    // As a last resort, you could uncomment:
    // location.reload();
  }
}

// ============================================
// MAIN THRESHOLD CHECKER
// ============================================

async function checkCartThreshold() {
  if (isProcessing) return;
  isProcessing = true;

  try {
    const cart = await getCart();
    if (!cart) return;

    const cartTotal = cart.total_price; // in cents
    const hasGift = isVariantInCart(cart, VARIANT_ID);

    console.log('-----------------------------------');
    console.log('Cart total: $' + (cartTotal / 100).toFixed(2));
    console.log('Threshold:  $' + (CART_THRESHOLD / 100).toFixed(2));
    console.log('Gift in cart:', hasGift);
    console.log('Variant ID:', VARIANT_ID);
    console.log('-----------------------------------');

    if (cartTotal >= CART_THRESHOLD && !hasGift) {
      console.log('✅ Threshold met – adding free gift');
      await addFreeGift(VARIANT_ID);
      setTimeout(hardRefreshCartUI, 300);
    } else if (cartTotal < CART_THRESHOLD && hasGift) {
      console.log('❌ Below threshold – removing free gift');
      await removeFreeGiftByVariant(VARIANT_ID);
      setTimeout(hardRefreshCartUI, 300);
    } else {
      console.log('ℹ️ No action needed');
    }
  } catch (e) {
    console.error('Error in checkCartThreshold:', e);
  } finally {
    isProcessing = false;
  }
}

// ============================================
// INTERCEPT CART OPERATIONS
// ============================================

const originalFetch = window.fetch;
window.fetch = async function (...args) {
  const [url] = args;
  const isCartOp =
    url.includes('/cart/add') ||
    url.includes('/cart/update') ||
    url.includes('/cart/change');

  const response = await originalFetch.apply(this, args);

  if (isCartOp && response.ok) {
    console.log('Cart operation detected:', url);
    setTimeout(checkCartThreshold, 800);
  }

  return response;
};

// Listen for Dawn cart events
document.addEventListener('cart:updated', () => {
  console.log('cart:updated event fired');
  setTimeout(checkCartThreshold, 500);
});

// Init
document.addEventListener('DOMContentLoaded', () => {
  console.log('🎁 Free Gift Monitor Initialized');
  console.log('Threshold: $' + (CART_THRESHOLD / 100).toFixed(2));
  console.log('Variant ID:', VARIANT_ID);
  setTimeout(checkCartThreshold, 1000);
});